import Cookies from "js-cookie";

const TokenKey = "hash-Admin-Token";
const MenusKey = "hash-Admin-menus";
const MenusCheckKey = "hash-Admin-Menus-Check";
const UserKey = "hash-Admin-user";
const LoginUserinfo = "hash-login-userinfo";// 当前用户登录的用户信息

export function setToken(token) {
  // 不保持登录，token在session周期内有效
  return sessionStorage.setItem(TokenKey, token);
}

export function getToken() {
  return sessionStorage.getItem(TokenKey) || Cookies.get(TokenKey);
}

export function setMenus(menus) {
  if (menus) {
    return sessionStorage.setItem(MenusKey, JSON.stringify(menus));
  }
}
export function getMenus() {
  const data = sessionStorage.getItem(MenusKey) || Cookies.get(MenusKey);
  let resultData = [];
  if (data) {
    resultData = JSON.parse(data);
  }
  return resultData;
}

export function setUser(user) {
  if (user) {
    return sessionStorage.setItem(UserKey, JSON.stringify(user));
  }
}

export function getUser() {
  const data = sessionStorage.getItem(UserKey) || Cookies.get(UserKey);
  let resultData = {};
  if (data) {
    resultData = JSON.parse(data);
  }
  return resultData;
}

/**
 * 设置当前登录的用户信息
 * @param user
 */
export function setLogionUserInfo(user) {
  if (user) {
    return sessionStorage.setItem(LoginUserinfo, JSON.stringify(user));
  }
}

/**
 * 获取当前登录的用户信息
 * @returns {{}}
 */
export function getLogionUserInfo() {
  const data =  sessionStorage.getItem(LoginUserinfo);
  let resultData = {};
  if (data) {
    resultData = JSON.parse(data);
  }
  console.log('获取当前登录的用户信息',resultData);
  return resultData;
}

/**
 * menus是否改变
 * @param bool
 */
export function setMenusCheckKey(bool) {
  return sessionStorage.setItem(MenusCheckKey, JSON.stringify(bool));
}

export function getMenusCheckKey() {
  return sessionStorage.getItem(MenusCheckKey) || false;
}

export function removeToken() {
  sessionStorage.removeItem(TokenKey);
  sessionStorage.removeItem(MenusKey);
  sessionStorage.removeItem(UserKey);
  sessionStorage.removeItem(MenusCheckKey);
  Cookies.remove(TokenKey);
  return;
}
